import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialQuillDocumentImageState: Dtos.QuillDocumentImage & IRegistrationFormState = {
    id: null,
    quillDocumentId: null,
    name: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IQuillDocumentImageReduxFormState {
    id: IFieldState<number>,
    quillDocumentId: IFieldState<number>,
    name: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
}
